<div class="superbonus">
  <img
    class="superbonus__icon"
    src="assets/images/superbonus/ico_superbonus_logo.svg"
  />

  <a
    class="superbonus__link"
    *ngIf="showQuestionButton"
    (click)="onOpenQuestion()"
  >
    {{ 'SUPERBONUS.BUTTON_HAVE_QUESTIONS' | translate }}
  </a>
  <a
    class="superbonus__link"
    *ngIf="!showQuestionButton"
    (click)="onConsultConditions()"
  >
    {{ 'SUPERBONUS.BUTTON_CONSULT_CONDITIONS' | translate }}
  </a>
</div>
